export default __webpack_public_path__ + "static/media/vu.282e59f9.svg";